/** Backpressure pause with an active-time budget; pausing does not consume the timeout. */
export class DownloadControl {
  private controller = new AbortController();
  readonly signal: AbortSignal;
  paused = false;
  private remaining: number;
  private started = 0;
  private timer: ReturnType<typeof setTimeout> | undefined;
  private disposed = false;
  private wake = new Set<() => void>();
  constructor(parent: AbortSignal, timeout = 180_000) {
    this.remaining = timeout;
    this.signal = AbortSignal.any([parent, this.controller.signal]);
    this.signal.addEventListener('abort', this.release, { once: true });
    this.arm();
  }
  private arm() { if (this.signal.aborted || this.paused) return; this.started = Date.now(); this.timer = setTimeout(() => this.controller.abort(new DOMException('下载超时', 'TimeoutError')), Math.max(0, this.remaining)); }
  private stop() { if (this.timer !== undefined) { clearTimeout(this.timer); this.timer = undefined; this.remaining -= Date.now() - this.started; } }
  private release = () => { this.stop(); for (const done of this.wake) done(); this.wake.clear(); };
  pause() { if (this.disposed || this.signal.aborted || this.paused) return false; this.stop(); this.paused = true; return true; }
  resume() { if (this.disposed || !this.paused) return; this.paused = false; this.arm(); this.releaseWaiters(); }
  private releaseWaiters() { for (const done of this.wake) done(); this.wake.clear(); }
  cancel() { this.controller.abort(new DOMException('该歌曲下载已取消', 'AbortError')); }
  async checkpoint() {
    this.signal.throwIfAborted();
    while (this.paused && !this.signal.aborted) await new Promise<void>(resolve => { this.wake.add(resolve); });
    this.signal.throwIfAborted();
  }
  dispose() { this.stop(); this.disposed = true; this.paused = false; this.signal.removeEventListener('abort', this.release); this.releaseWaiters(); }
}
